// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".status--UDOzb{color:red;border-color:red}", "",{"version":3,"sources":["webpack://./src/gui/Components/Status/Lost/index.module.scss"],"names":[],"mappings":"AAAA,eAAQ,SAAS,CAAC,gBAAgB","sourcesContent":[".status{color:red;border-color:red}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"status": "status--UDOzb"
};
export default ___CSS_LOADER_EXPORT___;
